// extracted by mini-css-extract-plugin
module.exports = {"seriesview":"series_seriesview__4GOsF"};